import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, computed, toRefs } from "vue";
import { useStore } from "vuex";
import { Booking } from "@/models";


export default /*#__PURE__*/_defineComponent({
  __name: 'StatusSelect',
  props: {
    pvm: {},
    changestatuspvmid: {}
  },
  emits: ["statuspvmselected"],
  setup(__props: any, { emit: __emit }) {

const store = useStore();
const statusList: string[] = [
  "Not due",
  "Due",
  "Scheduled and in queue",
];
const propertyvisitmanagement = computed(
  () => store.getters["propertyvisitmanagement/getBookingsData"]
);
const props = __props;
const emit = __emit;
const statusSelect = ref<{ [key: string]: HTMLElement | undefined }>({});
const setBookingsData = (data: Booking[]) =>
  store.commit("propertyvisitmanagement/setBookings", data);
const { pvm, changestatuspvmid } = toRefs(props);
const changeStatusReport = () => {
  emit("statuspvmselected", pvm.value.id);

  const dropdown = statusSelect.value[`statusSelect-${pvm.value.id}`] as any;
  if (dropdown) {
    dropdown.activate();
  }
};
const onSelectStatus = async (id: string | undefined, val: string) => {
  const pmIndex = propertyvisitmanagement.value.findIndex(
    (r: Booking) => r.id === id
  );
  propertyvisitmanagement.value[pmIndex].status = val;
  setBookingsData(propertyvisitmanagement.value);
  pvm.value.id = id;
  emit("statuspvmselected", "");
};
const closeDropdown = () => {
  emit("statuspvmselected", "");
};
const status = ref("");

return (_ctx: any,_cache: any) => {
  const _component_singleselect_text = _resolveComponent("singleselect-text")!

  return (_openBlock(), _createElementBlock("div", { onFocusout: closeDropdown }, [
    _withDirectives(_createVNode(_component_singleselect_text, {
      modelValue: status.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((status).value = $event)),
      options: statusList,
      "allow-empty": true,
      taggable: false,
      onSelect: _cache[2] || (_cache[2] = ($event: any) => (onSelectStatus(_unref(pvm).id, $event))),
      ref: 'statusSelect-' + _unref(pvm).id
    }, _createSlots({ _: 2 }, [
      (_unref(pvm).id)
        ? {
            name: "clear",
            fn: _withCtx(() => [
              _createElementVNode("i", {
                onMousedown: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (onSelectStatus(_unref(pvm).id, $event)), ["prevent","stop"])),
                class: "multiselect__clear fa fa-times",
                "aria-label": "Clear"
              }, null, 32)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["modelValue"]), [
      [_vShow, _unref(changestatuspvmid) === _unref(pvm).id]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass({ 'transparent-text': !_unref(pvm).status }),
      onClick: _cache[3] || (_cache[3] = ($event: any) => (changeStatusReport()))
    }, _toDisplayString(_unref(pvm).status ? _unref(pvm).status : "Select Dropdown"), 3), [
      [_vShow, _unref(changestatuspvmid) != _unref(pvm).id]
    ])
  ], 32))
}
}

})